import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import IntlProvider from './i18n/IntlProvider';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initializeDefines } from './util/defines';

// Custom imports:
import firebase from './config/firebase.json'
import { FirebaseAppProvider } from 'reactfire';



initializeDefines();

ReactDOM.render(<IntlProvider>
	<FirebaseAppProvider firebaseConfig={firebase}>
		<App />
	</FirebaseAppProvider>
</IntlProvider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
